<div id="clientList" class="card">
    <div class="card-header border-0">
        <div class=" d-grid d-sm-flex align-items-center">
            <h5 class="flex-grow-1 fs-17 " style="padding-top: 0.5%;" i18n="@@">Tasks List</h5>

            <a  class="btn btn-success" 
                i18n="@@List_Base_Button_CreateNew" (click)="createNewTask()">
                Create New Task
            </a>  

        </div>
    </div>
    <div class="card-body ">
        <div class="row g-3">
            <div class="col-md-6">
                <div class="d-flex align-items-center gap-2 ">
                    <div class="search-box flex-grow-1">
                        <input type="text" name="searchTerm" class="form-control search bg-light border-light"
                            placeholder="Search by file name" [(ngModel)]="taskListService.searchTerm">
                        <i class="ri-search-line search-icon"></i>
                        <i class="mdi mdi-close-circle search-widget-icon search-widget-icon-close"
                            *ngIf="taskListService.searchTerm && taskListService.searchTerm.length >0" style="font-size: 1rem;
                                    position: absolute;
                                    cursor: pointer;
                                    right: 13px;
                                    top: 0;
                                    height: 100%;
                                    display: flex;
                                    align-items: center;
                                    color: #878a99;" (click)="clearSearch(taskListService)"></i>
                    </div>
                </div>
            </div>


        </div>
    </div>

    <div class="card-body p-0">

        <div
            style="padding-right: 1rem; padding-left: 1rem; overflow: scroll; margin-bottom: 0; scrollbar-width: none; ">
            <div class="table-responsive table-card " style="margin-bottom: 0; margin-top: 0; overflow-y: hidden; ">
                <table class="table align-middle table-nowrap" style="margin-bottom: 0;">

                    <thead class="text-muted table-light">
                        <tr>
                            <th scope="col" style="width: 50px;">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="checkAll" value="option"
                                        style="cursor:pointer" [(ngModel)]="masterSelected"
                                        (change)="checkUncheckAll($event,listItems)">
                                </div>
                            </th>
                            <th scope="col" style="width:40%">
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Name</span>
                                </div>
                            </th>

                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Version</span>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Type</span>

                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Modified Date</span>

                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Is Processed</span>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Actions</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="list form-check-all">

                        <tr *ngFor="let data of listItems ; index as i" id="i_{{data.id}}">
                            <td scope="row">
                                <div class="form-check">
                                    <input id="checkboxId" class="form-check-input" type="checkbox" name="checkAll"
                                        style="cursor:pointer" (click)="stopPropagationOnClick($event)"
                                        value="{{data.id}}" (change)="onCheckboxChange($event, listItems)"
                                        [(ngModel)]="data.state">
                                </div>
                            </td>

                            <td>
                                <a href="javascript:void(0);">
                                    <ngb-highlight style="cursor:pointer" [result]="data.name" (click)="editTask(data)"
                                        [term]="taskListService.searchTerm">
                                    </ngb-highlight>
                                </a>

                            </td>

                            <td>
                                <ngb-highlight style="cursor:default" [result]="data.version"
                                    [term]="taskListService.searchTerm">
                                </ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight style="cursor:default" [result]="getType(data.type)"
                                    [term]="taskListService.searchTerm">
                                </ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight style="cursor:default" [result]="dateRename(data.modifiedDate)"
                                    [term]="taskListService.searchTerm">
                                </ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight style="cursor:default" [result]="data.isProcessed"
                                    [term]="taskListService.searchTerm">
                                </ngb-highlight>
                            </td>
                            <td>
                                <div class=" d-flex ">
                                    <ul class="list-inline hstack gap-2 mb-0">
                                        <li class="list-inline-item">
                                            <div class="dropdown" ngbDropdown style="z-index: 100;  position: static;">
                                                <button class="btn btn-soft-secondary btn-sm dropdown arrow-none"
                                                    type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                                    ngbDropdownToggle>
                                                    <i class="ri-more-fill align-middle"></i>
                                                </button>
                                                <ul class="dropdown-menu " ngbDropdownMenu
                                                    style=" position: absolute; ">
                                                    <li><button [disabled]="submitted"
                                                            class="dropdown-item edit-item-btn" style="cursor:pointer"
                                                            data-bs-toggle="modal" (click)="editTask(data)"><i
                                                                class="ri-edit-line align-bottom me-2 text-muted"></i>
                                                            Edit</button></li>
                                                    <li><a class="dropdown-item edit-item-btn" data-bs-toggle="modal"
                                                            style="cursor: pointer;"
                                                            (click)="executeOperation(data.id)">
                                                            <i
                                                                class="bx bx-skip-next-circle align-bottom me-2 text-muted"></i>
                                                            Execute</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>

            </div>
        </div>
    </div>

    <div class=" card-body ">
        <div class="row justify-content-md-between align-items-md-center">
            <div class="col col-sm-6">
                <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                    {{pagingInfo(taskListService)}}
                </div>
            </div>
            <div class="col col-sm-6">
                <div class="text-sm-right float-end listjs-pagination">
                    <ngb-pagination [collectionSize]="(total | async)!" [(page)]="taskListService.startIndex">
                        <ng-template ngbPaginationPages let-page let-pages="pages">
                            <li class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                                <div class="mb-3 d-flex flex-nowrap px-2">
                                    <label id="paginationInputLabel" for="paginationInput"
                                        class="col-form-label me-2 ms-1" i18n="@@Pagination_Text_Page">Page</label>
                                    <input #i type="text" inputmode="numeric" pattern="[0-9]*"
                                        class="form-control custom-pages-input" id="paginationInput"
                                        [value]="taskListService.startIndex"
                                        (keyup.enter)="selectPage(taskListService,i.value)"
                                        (blur)="selectPage(taskListService,i.value)"
                                        (input)="formatPageInput($any($event).target)"
                                        aria-labelledby="paginationInputLabel paginationDescription"
                                        style="text-align: center; width:3.5rem;" />
                                    <span id="paginationDescription" class="col-form-label text-nowrap px-2 ">
                                        <span i18n="@@Pagination_Text_Of">of</span> {{pages.length}}</span>
                                </div>
                            </li>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isLoadingVal" id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>

</div>